<template>
    <div class="core">
        <div class="layui-fluid">
          <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig">
              <button class="layui-btn" title="新增资料" @click="add()" style="margin-left:10px">
                <i class="layui-icon">&#xe624;</i>
                新增资料
              </button>
           </pub-search>
                <layui-table
                  requestUniqueId="getStorageList_tmp"
                  ref="storage"
                  table-name="YW_STORAGE"
                  view-name="YW_STORAGE_DETAIL"
                  :sort="['CREATE_TIME:DESC']"
                  :page-size="20"
                  :page-range="6"
                  :page-options="[10, 20, 50, 100]"
                  :renderRow="renderRow"
                  :skin="'line'"
                  @table-event-edit="edit($event)"
                  @table-event-detail="detail($event)"
                  @table-event-del="tableObj.delRows($event.data)">
                  <div>
                      <div checkbox="true" align="center" width="60"></div>
                      <layui-tableconfig :config = "tableList"></layui-tableconfig>
                      <div rowspan="3" align="center" fixed="right" title="操作" width="130">
                          <script type="text/html" v-pre>
                              <a class=" layui-btn-xs" lay-event="detail">查看</a>
                              <a class=" layui-btn-xs" lay-event="edit">编辑</a>
                              <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del">删除</a>
                          </script>
                      </div>
                  </div>
              </layui-table>
        </div>
        <div v-show="formShow" id="storageForm">
            <storageForm  ref="storageForm"/>
        </div>
    </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import storageForm from "./storageForm"
export default {
  name: 'storage',
  components: {
    storageForm
  },
  data () {
    return {
        tableObj: {
            checkedRows: 0,
            queryObject: {}
        },
        tableList:[
          { field: 'STORAGE_NAME', title: '资料名称', width: '180'},
          { field: 'BRAND_NAME', title: '品牌名称', width: '180'},
          { field: 'STORAGE_FILES_DESC', title: '相关附件', height: 'auto'},
          { field: 'CREATE_TIME', title: '创建时间', width: '160' },
          { field: 'STORAGE_REMARK', title: '备注' , width: '220'}
        ],
        searchConfig: {
          basic: [
            { TYPE:'input', WIDTH: 260,  FIELD: 'STORAGE_NAME:2,STORAGE_REMARK:2', PLACEHOLDER: '请输入搜索条件'},
          ],
        },
        formShow: false,
    }
  },
  mounted() {
    this.storageForm = this.$refs.storageForm;
    this.tableObj = this.$refs.storage;
    this.tableObj.load();
  },
  methods: {
    renderRow(row){
      if(row.STORAGE_FILES_DESC) {
        return row.STORAGE_FILES_DESC.split(',').join('、')
        var arr = row.STORAGE_FILES_DESC.split(',');
        var arr2 = [];
        for(var i = 0 ; i < arr.length; i++){
          arr2.push('<span style="display:inline-flex;margin:5px 10px; border: 1px solid #CCCCCC;border-radius: 16px;background-color: #F1F6FF;line-height: 30px;height: 30px;padding:0px 4px">' + arr[i] + '</span>')
        }
        row.STORAGE_FILES_DESC = '<div style="display:flex;flex-wrap: wrap;">' + arr2.join('') + '</div>';
      }
    },
    add () {
      this.formShow = true;
      this.storageForm.storageForm.setEditRow(null);
      this.storageForm.tableObj = this.tableObj;
      let targetEl = $('.layui-body')
      this.layer.openWin("storageForm", '新增资料库', null, targetEl, { offset: [ targetEl.offset().top ,0] });
    },
    edit($event){
      this.formShow = true;
      this.storageForm.tableObj = this.tableObj;
      this.storageForm.storageForm.setEditRow($event.data);
      // let targetEl = $(this.$el)
      let targetEl = $('.layui-body')
      this.layer.openWin("storageForm", '编辑资料库', null, targetEl, { offset: [targetEl.offset().top, 0]});
    },
    detail($event) {
      this.baseComponent.smartLoadComponent('storageBrowserForm', {
        editRow: $event.data,
        tableObj: this.tableObj,
        title: '查看资料库',
      });
    },
    search() {
        this.tableObj.load()
    },
    reset() {
      this.tableObj.queryObject = {}
      this.tableObj.load()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/workOrder/storage/index.vue